// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}

th,
td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

th {
  background-color: #0b2d71;
  font-weight: bold;
}

td a {
  color: blue;
  text-decoration: none;
}

.color {
  color: #0b2d71;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.filter-input {
  width: 150px;
  height: 32px;
}

.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }
.center-content {
  margin: auto !important;
  text-align: center;
}

.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}

.bordered-container {
  border: 1px solid #d3d3d3;
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
  padding-bottom: 1%;
}
.label-width {
  width: 10%;
}

.label-width {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/bycostcenter/bycostcenter.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;AACF;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\n\nth,\ntd {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\nth {\n  background-color: #0b2d71;\n  font-weight: bold;\n}\n\ntd a {\n  color: blue;\n  text-decoration: none;\n}\n\n.color {\n  color: #0b2d71;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.filter-input {\n  width: 150px;\n  height: 32px;\n}\n\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n\n.error-message {\n  color: red;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.bordered-container {\n  border: 1px solid #d3d3d3;\n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n  padding-bottom: 1%;\n}\n.label-width {\n  width: 10%;\n}\n\n.label-width {\n  width: 10%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
